import React from "react";

// import { Container } from './styles';

const SignUp: React.FC = () => {
  return <div>SignUp</div>;
};

export default SignUp;
